module.exports = require("@splunk/dashboard-visualizations/FillerGauge");